<template>
  <UPopover mode="hover">
    <a class="block py-2 px-3 rounded font-medium hover:bg-action hover:text-action transition-all text-[var(--bookapp-hero-text-color)] cursor-pointer">
      {{ item.name || item.icon }}
    </a>

    <template #panel>
      <div class="p-2 space-y-2 text-sm">
        <LayoutElementsNavigationItem
          v-for="child in item.children"
          :key="`${child.id}-${child.type}`"
          :item="child"
          icon
          info
          class="text-left"
        />
      </div>
    </template>
  </UPopover>
</template>

<script>
import NavigationItem from './NavigationItem'

export default {
  components: {
    NavigationItem
  },
  props: {
    item: {
      type: Object,
      required: true
    }
  }
}
</script>
